export default __webpack_public_path__ + "static/about-10-0cb1ab98224034fc2d1675f88798551e.png";